import React, { useState, useEffect, useContext } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import axios from 'axios';
import { useDebounce } from 'use-debounce';
import { api } from '../../../api/api';

import { GlobalTypes } from 'types/global';
import Container from '@mui/material/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { DateTimePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { FormControl, MenuItem, InputLabel, Switch } from '@mui/material';

import { GlobalContext } from '../../../context/GobalState';
import { insert } from '../../../helpers';

import Button from '../../atoms/Button/Button';
import Input from 'components/atoms/Input/Input';
import TableComponent from 'components/molecules/TableComponent/TableComponent';
import TreeSelectMenu from '../../organisms/TreeSelect/TreeSelectMenu';
import TimeInput from 'components/atoms/TimeInput/TimeInput';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { SortBtn, DurationTable } from '../../molecules/TableComponent/TableComponent.styles';

import {
  BusinessSelect,
  FirstRow,
  StatusSelect,
  timeTextFieldStyle,
  dateTimeTextFieldStyle,
  SecondRow,
  DurationCell,
  DateTimePickerWrapper,
} from './ItemsList.styles';
import { Select } from '@mui/material';

const ItemsList = () => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [totalConnections, setTotalConnections] = useState(0);
  const [numberOfConversations, setNumberOfConversations] = useState(0);
  const [searchLogicalStatus, setSearchLogicalStatus] = useState('');
  const [searchBusinessStatus, setSearchBusinessStatus] = useState('');
  const [searchRatingOption, setSearchRatingOption] = useState('');
  const [searchProcessingOptions, setSearchProcessingOptions] = useState('');
  const [searchTags, setSearchTags] = useState('');
  const [searchScenario, setSearchScenario] = useState('');
  const [selectedLogicalOptions, setSelectedLogicalOptions] = useState([]);
  const [selectedBusinessOptions, setSelectedBusinessOptions] = useState([]);
  const [selectedRatingOption, setSelectedRatingOption] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [sortNameColumnDesc, setSortNameColumnDesc] = useState('');
  const [sortNameColumnAsc, setSortNameColumnAsc] = useState('');
  const [startDuration, setStartDuration] = useState('');
  const [endDuration, setEndDuration] = useState('');
  const [startDurationValue, setStartDurationValue] = useState('00:00');
  const [endDurationValue, setEndDurationValue] = useState('59:59');
  const [startDateTime, setStartDateTime] = useState('');
  const [endDateTime, setEndDateTime] = useState('');
  const [startTimeHour, setStartTimeHour] = useState('');
  const [endTimeHour, setEndTimeHour] = useState('');
  const [startDateTimeValue, setStartDateTimeValue] = useState(new Date());
  const [endDateTimeValue, setEndDateTimeValue] = useState(new Date());
  const [phoneNumberValue, setPhoneNumberValue] = useState('');
  const [leadNumberValue, setLeadNumberValue] = useState('');
  const [downloadSelectedLogsLink, setDownloadSelectedLogsLink] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);
  const [logicalOptions, setLogicalOptions] = useState([]);
  const [ratingOptions, setRatingOptions] = useState([]);
  const [businessOptions, setBusinessOptions] = useState([]);
  const [processingOptions, setProcessingOptions] = useState([]);
  const [abScenarios, setAbScenarios] = useState([]);
  const [tags, setTags] = useState([]);
  const [advFilters, setAdvFilters] = useState(false);
  const [noDecoration] = useState('true');
  const [campaignName, setCampaignName] = useState('');
  const [timeStart, setTimeStart] = useState();
  const [timeEnd, setTimeEnd] = useState();
  const [timeValue, setTimeValue] = useState(new Date());
  const [conPerLeadStart, setConPerLeadStart] = useState(0);
  const [conPerLeadEnd, setConPerLeadEnd] = useState(0);
  const [totalTime, setTotalTime] = useState('');
  const [extension, setExtension] = useState('csv');
  const [vectorName, setVectorName] = useState('none');
  const [direction, setDirection] = useState('inout');

  const [debouncedStartDuration] = useDebounce(startDuration, 500);
  const [debouncedEndDuration] = useDebounce(endDuration, 500);
  const [debouncedStartDateTime] = useDebounce(startDateTime, 500);
  const [debouncedEndDateTime] = useDebounce(endDateTime, 500);
  const [debouncedStartHour] = useDebounce(startTimeHour, 500);
  const [debouncedEndHour] = useDebounce(endTimeHour, 500);

  const { authToken, skill, campaign, permissionLevel } = useContext(GlobalContext);
  const handleError = useErrorHandler();

  useEffect(() => {
    let url = `${api}data/data/?campaign=${campaign}`;
    url += `&page=${page + 1}`;
    url += `&page_size=${rowsPerPage}`;
    if (phoneNumberValue) {
      url += `&search=${phoneNumberValue.replace(/\s/g, '')}`;
    }
    if (leadNumberValue) {
      url += `&search=${leadNumberValue}`;
    }
    if (searchLogicalStatus) {
      url += `&logical_status=${searchLogicalStatus}`;
    }
    if (searchBusinessStatus) {
      url += `&business_status_talk=${searchBusinessStatus}`;
    }
    if (searchProcessingOptions) {
      url += `&processing_status=${searchProcessingOptions}`;
    }
    if (searchTags) {
      url += `&tags=${searchTags}`;
    }
    if (searchRatingOption) {
      url += `&rating_options=${searchRatingOption}`;
    }
    if (searchScenario) {
      url += `&ab_scenarios=${searchScenario}`;
    }
    if (sortNameColumnDesc) {
      url += `&ordering=-${sortNameColumnDesc},-pk`;
    }
    if (sortNameColumnAsc) {
      url += `&ordering=${sortNameColumnAsc},-pk`;
    }

    if (debouncedStartDuration && debouncedEndDuration) {
      url += `&duration=${debouncedStartDuration},${debouncedEndDuration}`;
    }
    if (debouncedStartDuration && !debouncedEndDuration) {
      url += `&duration=${debouncedStartDuration},${'59:59'}`;
    }
    if (!debouncedStartDuration && debouncedEndDuration) {
      url += `&duration=${'00:00'},${debouncedEndDuration}`;
    }

    if (debouncedStartDateTime && debouncedEndDateTime) {
      url += `&date=${debouncedStartDateTime},${debouncedEndDateTime}`;
    }
    if (debouncedStartDateTime && !debouncedEndDateTime) {
      url += `&date=${debouncedStartDateTime},${new Date().toISOString()}`;
    }
    if (!debouncedStartDateTime && debouncedEndDateTime) {
      url += `&date=${new Date().toISOString()},${debouncedEndDateTime}`;
    }
    if (conPerLeadStart && conPerLeadEnd) {
      url += `&number_calls=${conPerLeadStart},${conPerLeadEnd}`;
    }
    if (!conPerLeadStart && conPerLeadEnd) {
      url += `&number_calls=0,${conPerLeadEnd}`;
    }
    if (conPerLeadStart && !conPerLeadEnd) {
      url += `&number_calls=${conPerLeadStart},100`;
    }
    if (debouncedStartHour && debouncedEndHour) {
      url += `&everyday_time_range=${debouncedStartHour},${debouncedEndHour}`;
    }
    if (direction) {
      url += `&in_out_all=${direction}`;
    }
    // if (!debouncedStartHour && debouncedEndHour) {
    //   url += `&everyday_time_range=${timeValue},${debouncedEndHour}`;
    // }
    // if (debouncedStartHour && !debouncedEndHour) {
    //   url += `&everyday_time_range=${debouncedStartHour},${timeValue}`;
    // }

    authToken &&
      campaign &&
      axios
        .get(url, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setItems(data.results);
          setTotalRows(data.count);
          setTotalConnections(data.connections_count);
          setTotalTime(data.connections_total_time);
        })
        .then((error) => {
          setError('No results found');
        })
        .catch((error) => {
          handleError(error);
        });
  }, [
    page,
    rowsPerPage,
    searchLogicalStatus,
    searchBusinessStatus,
    searchProcessingOptions,
    searchTags,
    searchRatingOption,
    searchScenario,
    sortNameColumnDesc,
    sortNameColumnAsc,
    phoneNumberValue,
    leadNumberValue,
    authToken,
    handleError,
    numberOfConversations,
    debouncedStartDuration,
    debouncedEndDuration,
    debouncedStartDateTime,
    debouncedEndDateTime,
    debouncedStartHour,
    debouncedEndHour,
    campaign,
    conPerLeadStart,
    conPerLeadEnd,
    timeValue,
    direction,
  ]);
  useEffect(() => {
    if (authToken && campaign) {
      axios
        .get(`${api}data/logical_status/?campaign=${campaign}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setLogicalOptions(data);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [handleError, authToken, campaign]);
  useEffect(() => {
    if (authToken && campaign) {
      axios
        .get(`${api}data/business_status/?campaign=${campaign}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setBusinessOptions(data);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [handleError, authToken, campaign]);
  useEffect(() => {
    if (authToken && campaign) {
      axios
        .get(`${api}data/processing_status/?campaign=${campaign}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setProcessingOptions(data);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [handleError, authToken, campaign]);
  useEffect(() => {
    if (authToken && skill) {
      axios
        .get(`${api}data/tags_filter/?skill=${skill}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setTags(data);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [handleError, authToken, skill]);

  // Update items if new items
  useEffect(() => {
    // Get initial number of conversations during first render
    authToken &&
      axios
        .get(`${api}data/number/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setNumberOfConversations(data.count);
        })
        .catch((error) => {
          handleError(error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshList = () => {
    axios
      .get(`${api}data/number/`, {
        headers: {
          Authorization: `token ${authToken}`,
        },
      })
      .then(({ data }) => {
        setNumberOfConversations(data.count);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelectedItems([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortColumnDesc = (e) => {
    setSortNameColumnAsc('');
    setSortNameColumnDesc(e.currentTarget.name);
  };

  const sortColumnAsc = (e) => {
    setSortNameColumnDesc('');
    setSortNameColumnAsc(e.currentTarget.name);
  };

  const onStartDuration = (event) => {
    let x = event.target.value;
    if (event.target.value.replace(/[^0-9]/g, '').length <= 4) {
      if (event.target.value.length === 3 && !event.target.value.split('').includes(':')) {
        event.target.value = insert(x, 2, ':').join('');
      }
    }
    setStartDurationValue(event.target.value);
    setStartDuration(event.target.value.match(/\d+:[0-5]\d/));
  };

  const onEndDuration = (event) => {
    let x = event.target.value;
    if (event.target.value.replace(/[^0-9]/g, '').length <= 4) {
      if (event.target.value.length === 3 && !event.target.value.split('').includes(':')) {
        event.target.value = insert(x, 2, ':').join('');
      }
    }
    setEndDurationValue(event.target.value);
    setEndDuration(event.target.value.match(/\d+:[0-5]\d/));
  };

  const addStartDateTime = (value) => {
    if (value instanceof Date && !isNaN(value)) {
      const start = value.toISOString();
      setStartDateTime(start);
    }
  };

  const addEndDateTime = (value) => {
    if (value instanceof Date && !isNaN(value)) {
      const end = value.toISOString();
      setEndDateTime(end);
    }
  };

  const addStartTimeHour = (value) => {
    if (value instanceof Date && !isNaN(value)) {
      const start = value.getHours() + ':' + (value.getMinutes() < 10 ? '0' : '') + value.getMinutes();
      setStartTimeHour(start);
    }
  };

  const addEndTimeHour = (value) => {
    if (value instanceof Date && !isNaN(value)) {
      const end = value.getHours() + ':' + (value.getMinutes() < 10 ? '0' : '') + value.getMinutes();
      setEndTimeHour(end);
    }
  };

  const addSelectedLogical = (selected) => {
    setSearchLogicalStatus(selected.join(','));
  };
  const addSelectedBusiness = (selected) => {
    setSearchBusinessStatus(selected.join(','));
  };
  const addSelectedRatingOption = (selected) => {
    setSearchRatingOption(selected.join(','));
  };
  const addSelectedProcessingOption = (selected) => {
    setSearchProcessingOptions(selected.join(','));
  };
  const addSelectedScenario = (selected) => {
    setSearchScenario(selected.join(','));
  };
  const addSelectedTags = (selected) => {
    setSearchTags(selected.join(','));
    setSelectedTags(selected);
  };

  const onPhoneNumber = (e) => {
    setPhoneNumberValue(e.target.value);
  };

  const onLeadNumber = (e) => {
    setLeadNumberValue(e.target.value);
  };

  const resetDateTime = () => {
    setStartDateTimeValue(new Date());
    setEndDateTimeValue(new Date());
    setStartDateTime('');
    setEndDateTime('');
    setSortNameColumnAsc('');
    setSortNameColumnDesc('');
  };

  const resetDuration = () => {
    setStartDuration('');
    setEndDuration('');
    setStartDurationValue('00:00');
    setEndDurationValue('59:59');
    setSortNameColumnAsc('');
    setSortNameColumnDesc('');
  };
  const resetTimeRange = () => {
    setTimeStart();
    setTimeEnd();
    setStartTimeHour('');
    setEndTimeHour('');
  };
  const resetAll = () => {
    setPhoneNumberValue('');
    setLeadNumberValue('');
    setSearchLogicalStatus('');
    setSearchBusinessStatus('');
    setSearchProcessingOptions('');
    setSearchTags('');
    setSelectedLogicalOptions([]);
    setSelectedBusinessOptions([]);
    setSelectedTags([]);
    resetDuration();
    resetDateTime();
    resetTimeRange();
    setConPerLeadEnd(0);
    setConPerLeadStart(0);
    setVectorName('none');
    setSelectedRatingOption([]);
    setDirection('inout');
    setSearchScenario('');
  };
  const onMultiSelectLogical = (selected) => {
    addSelectedLogical(selected);
  };
  const onMultiSelectBusiness = (selected) => {
    addSelectedBusiness(selected);
  };
  const onMultiSelectTag = (selected) => {
    addSelectedTags(selected);
  };
  const onMultiSelectRating = (selected) => {
    addSelectedRatingOption(selected);
  };
  const onMultiSelectScenario = (selected) => {
    addSelectedScenario(selected);
  };
  const onMultiSelectProcessing = (selected) => {
    addSelectedProcessingOption(selected);
  };

  const expandFilters = () => {
    setAdvFilters(!advFilters);
  };
  useEffect(() => {
    if (!!selectedItems.length && authToken) {
      setIsDownloadingAll(true);
      (async () => {
        const result = await fetch(`${api}data/download_package_of_logs/?logs=${selectedItems.join(',')}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        });
        const blob = await result.blob();
        if (result) {
          setIsDownloadingAll(false);
        }
        if (blob) {
          setDownloadSelectedLogsLink(URL.createObjectURL(blob));
        } else {
          console.warn('Error while downloading a blob');
        }
      })();
    }
  }, [selectedItems, authToken]);
  useEffect(() => {
    if (authToken && permissionLevel === GlobalTypes.PERMISSION_LEVEL_E && skill) {
      axios
        .get(`${api}data/talk_rating/get_options_as_tree/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setRatingOptions(data);
        })
        .catch((error) => {
          handleError(error);
        });
    }
    // eslint-disable-next-line
  }, [handleError, authToken, skill]);
  useEffect(() => {
    if (authToken && campaign) {
      axios
        .get(`${api}data/get_ab_scenarios_options/?campaign=${campaign}`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          setAbScenarios(data);
        })
        .catch((error) => {
          handleError(error);
        });
    }
  }, [handleError, authToken, campaign]);

  const onDownload = (extension) => {
    const params = {
      campaign: campaign,
      search: `${phoneNumberValue}`,
      logical_status: `${searchLogicalStatus}`,
      business_status_talk: `${searchBusinessStatus}`,
      tags: `${searchTags}`,
      rating_options: `${searchRatingOption}`,
      ordering: `${sortNameColumnDesc}`,
      duration:
        debouncedStartDuration && debouncedEndDuration
          ? `${debouncedStartDuration},${debouncedEndDuration}`
          : !debouncedStartDuration && debouncedEndDuration
          ? `00:00,${debouncedEndDuration}`
          : debouncedStartDuration && !debouncedEndDuration
          ? `${debouncedStartDuration},59:59`
          : null,
      date:
        debouncedStartDateTime && debouncedEndDateTime
          ? `${debouncedStartDateTime},${debouncedEndDateTime}`
          : !debouncedStartDateTime && debouncedEndDateTime
          ? `${new Date().toISOString()},${debouncedEndDateTime}`
          : debouncedStartDateTime && !debouncedEndDateTime
          ? `${debouncedStartDateTime},${new Date().toISOString()}`
          : null,
      number_calls: '',
      everyday_time_range: debouncedStartHour && debouncedEndHour ? `${debouncedStartHour},${debouncedEndHour}` : null,
      extension: extension,
    };
    axios
      .get(`${api}data/raport/`, {
        headers: {
          Authorization: `token ${authToken}`,
        },
        params: params,
        responseType: 'blob',
      })
      .then((response) => {
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'raport.zip'); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
  };

  return (
    <Container>
      <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
          <Input
            debounceTimeout={300}
            type="search"
            name="lead_number"
            placeholder="Search by Lead ID or Phone Number..."
            onChange={onLeadNumber}
            value={leadNumberValue}
            autoComplete="off"
            style={{ width: '25%', marginRight: '10px' }}
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePickerWrapper>
              <p>from:</p>
              <DateTimePicker
                renderInput={(props) => <TextField sx={dateTimeTextFieldStyle} {...props} />}
                value={startDateTimeValue}
                inputFormat="dd/MM/yyyy hh:mm"
                onChange={(newValue) => {
                  addStartDateTime(newValue);
                  setStartDateTimeValue(newValue);
                }}
                ampm={false}
              />
            </DateTimePickerWrapper>
            <DateTimePickerWrapper>
              <p>to:</p>
              <DateTimePicker
                renderInput={(props) => <TextField sx={dateTimeTextFieldStyle} {...props} />}
                value={endDateTimeValue}
                inputFormat="dd/MM/yyyy hh:mm"
                onChange={(newValue) => {
                  addEndDateTime(newValue);
                  setEndDateTimeValue(newValue);
                }}
                ampm={false}
              />
            </DateTimePickerWrapper>
          </LocalizationProvider>
          <BusinessSelect>
            <p>Business Status</p> <TreeSelectMenu data={businessOptions} onChange={onMultiSelectBusiness} />
          </BusinessSelect>
          <BusinessSelect>
            <p>Tags</p> <TreeSelectMenu data={tags} onChange={onMultiSelectTag} />
          </BusinessSelect>
          {permissionLevel === GlobalTypes.PERMISSION_LEVEL_E ? (
            <BusinessSelect>
              <p>Advanced Filters</p>
              {advFilters ? (
                <ExpandLessIcon onClick={expandFilters} sx={{ cursor: 'pointer' }} />
              ) : (
                <ExpandMoreIcon onClick={expandFilters} sx={{ cursor: 'pointer' }} />
              )}
            </BusinessSelect>
          ) : (
            ''
          )}

          <Button onClick={resetAll} nodecoration={noDecoration}>
            <p>Cancel Filters</p>
          </Button>
          <Button onClick={refreshList} nodecoration={noDecoration}>
            <p>Refresh List</p>
            <FontAwesomeIcon icon={faRedo} style={{ marginLeft: '10px', width: '10px', height: '10px' }} />
          </Button>
        </Box>
      </Box>
      {advFilters ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'end',
            width: '100%',
            borderTop: 1,
            borderColor: '#87878c',
          }}
        >
          <FirstRow>
            <p>Connections per record</p>
            <p>Vector</p>
            <p>Transcription</p>
            <p>Rating categories</p>
            <p>
              Time span
              <SortBtn type="button" name="start_time" onClick={resetTimeRange}>
                <FontAwesomeIcon icon={faRedo} />
              </SortBtn>
            </p>
            <p>Call direction</p>
            <p>Scenario A/B</p>
            <p>Processing Status</p>
            <p>Logical Status</p>
            <p>
              Talk Duration
              <SortBtn type="button" name="start_time" onClick={resetDuration}>
                <FontAwesomeIcon icon={faRedo} />
              </SortBtn>
            </p>
          </FirstRow>
          <SecondRow>
            <Box sx={{ width: '12%', ml: 2 }}>
              <DateTimePickerWrapper>
                <p>From:</p>
                <FormControl sx={{ width: '50%' }} size="small">
                  <InputLabel id="demo-select-small"></InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={conPerLeadStart}
                    label=""
                    onChange={(e) => setConPerLeadStart(e.target.value)}
                    // disabled={true}
                    sx={{ height: '17px', fontSize: '15px' }}
                  >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                  </Select>
                </FormControl>
              </DateTimePickerWrapper>
              <DateTimePickerWrapper>
                <p>To:</p>
                <FormControl sx={{ width: '50%', mb: 1, mt: 1 }} size="small">
                  <InputLabel id="demo-select-small"></InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={conPerLeadEnd}
                    label=""
                    onChange={(e) => setConPerLeadEnd(e.target.value)}
                    // disabled={true}
                    sx={{ height: '17px', fontSize: '15px' }}
                  >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={11}>11</MenuItem>
                    <MenuItem value={12}>12</MenuItem>
                  </Select>
                </FormControl>
              </DateTimePickerWrapper>
            </Box>
            <Box sx={{ width: '9%' }}>
              <FormControl sx={{ width: '100%' }} size="small">
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={vectorName}
                  label=""
                  onChange={(e) => setVectorName(e.target.value)}
                  // disabled={true}
                  sx={{ fontSize: '13px' }}
                >
                  <MenuItem value={'none'}>None</MenuItem>
                  <MenuItem value={'10'}>Vector 1</MenuItem>
                  <MenuItem value={'20'}>Vector 2</MenuItem>
                  <MenuItem value={'30'}>Vector 3</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ width: '10%' }}>
              <Input
                debounceTimeout={300}
                type="search"
                name="lead_number"
                placeholder="Search..."
                onChange={onLeadNumber}
                value={leadNumberValue}
                autoComplete="off"
                style={{ width: '100%', marginTop: 3, marginLeft: 5 }}
                disabled={true}
              />
            </Box>
            <Box sx={{ width: '10%', display: 'flex', justifyContent: 'center', pr: 4 }}>
              <StatusSelect>
                <TreeSelectMenu data={ratingOptions} onChange={onMultiSelectRating} />
              </StatusSelect>
            </Box>
            <Box sx={{ width: '12%' }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePickerWrapper>
                  <p>From:</p>
                  <TimePicker
                    value={timeStart}
                    onChange={(newValue) => {
                      addStartTimeHour(newValue);
                      setTimeStart(newValue);
                    }}
                    renderInput={(props) => <TextField sx={timeTextFieldStyle} {...props} />}
                    ampm={false}
                  />
                </DateTimePickerWrapper>
                <DateTimePickerWrapper>
                  <p>To:</p>
                  <TimePicker
                    value={timeEnd}
                    onChange={(newValue) => {
                      addEndTimeHour(newValue);
                      setTimeEnd(newValue);
                    }}
                    renderInput={(props) => <TextField sx={timeTextFieldStyle} {...props} />}
                    ampm={false}
                  />
                </DateTimePickerWrapper>
              </LocalizationProvider>
            </Box>
            <Box sx={{ width: '10%' }}>
              <FormControl sx={{ width: '63%' }} size="small">
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={direction}
                  label=""
                  onChange={(e) => setDirection(e.target.value)}
                  // disabled={true}
                  sx={{ height: '17px', fontSize: '15px' }}
                >
                  <MenuItem value={'inout'}>All</MenuItem>
                  <MenuItem value={'in'}>In</MenuItem>
                  <MenuItem value={'out'}>Out</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ width: '10%', display: 'flex', justifyContent: 'center', pr: 6 }}>
              <StatusSelect>
                <TreeSelectMenu data={abScenarios} onChange={onMultiSelectScenario} />
              </StatusSelect>
            </Box>
            <Box sx={{ width: '10%', display: 'flex', justifyContent: 'center', pr: 6 }}>
              <StatusSelect>
                <TreeSelectMenu data={processingOptions} onChange={onMultiSelectProcessing} />
              </StatusSelect>
            </Box>
            <Box sx={{ width: '10%', display: 'flex', justifyContent: 'center', pr: 6 }}>
              <StatusSelect>
                <TreeSelectMenu data={logicalOptions} onChange={onMultiSelectLogical} />
              </StatusSelect>
            </Box>
            <Box sx={{ width: '10%' }}>
              <DurationCell>
                <DurationTable>
                  <tbody>
                    <tr>
                      <th>
                        <label htmlFor="duration-from">
                          <p style={{ textAlign: 'end', width: '30px', marginRight: '10px', fontSize: '12px' }}>
                            From:
                          </p>
                          <TimeInput value={startDurationValue} onChange={onStartDuration} />
                        </label>
                      </th>
                    </tr>
                    <tr>
                      <th>
                        <label htmlFor="duration-to">
                          <p style={{ textAlign: 'end', width: '30px', marginRight: '10px', fontSize: '12px' }}>To:</p>
                          <TimeInput value={endDurationValue} onChange={onEndDuration} />
                        </label>
                      </th>
                    </tr>
                  </tbody>
                </DurationTable>
              </DurationCell>
            </Box>
          </SecondRow>
        </Box>
      ) : (
        ''
      )}

      <TableComponent
        items={items}
        error={error}
        sortColumnDesc={sortColumnDesc}
        sortColumnAsc={sortColumnAsc}
        totalRows={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        totalConnections={totalConnections}
        setCampaignName={setCampaignName}
        onDownload={onDownload}
        totalTime={totalTime}
      />
    </Container>
  );
};

export default ItemsList;
